import React from 'react';

import { OilSettings } from 'screens/shared';

const GasTransOil = (props) => {
  const engineValues = {
    normal: '250.0',
    reset: '500.0'
  };

  return <OilSettings engineValues={engineValues} {...props} />;
};

export default GasTransOil;



// WEBPACK FOOTER //
// ./src/screens/Gas/GasSettings/GasTransOil/GasTransOil.js